export class Kariera {

    static init() {
        Kariera.iframe();
    }

    static iframe() {
        var $ = jQuery;

        document.querySelectorAll('iframe.kariera-widget').forEach(function(element) {
            var initialized = false;

            // On iframe load
            element.addEventListener('load', function() {
                Kariera.resizeIframe(element);
            });

            // On window scroll
            window.addEventListener('scroll', function() {
                if(!initialized) {
                    Kariera.resizeIframe(element);
                    initialized = true;
                }
            });

            // On window resize
            window.addEventListener('resize', function() {
                Kariera.resizeIframe(element);
            });
        });
    }

    static resizeIframe(obj) {
        console.log(obj);

        obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
        obj.classList.add('is-visible');
    }
}